import { render } from "./VariantsFrame.vue?vue&type=template&id=3bf4ca6c&scoped=true"
import script from "./VariantsFrame.vue?vue&type=script&lang=js"
export * from "./VariantsFrame.vue?vue&type=script&lang=js"

import "./VariantsFrame.vue?vue&type=style&index=0&id=3bf4ca6c&scoped=true&lang=css"

import exportComponent from "D:\\dev\\DiagDev-clean\\Projets autres\\AdminWSInterface\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bf4ca6c"]])

export default __exports__